import api from './client';

export const getImages    = (params)       => api.get('/images', { params });
export const getImage     = (id)           => api.get(`/images/${id}`);
export const uploadImage  = (formData, onProgress) =>
  api.post('/images', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
  });
export const updateImage  = (id, data)     => api.patch(`/images/${id}`, data);
export const deleteImage  = (id)           => api.delete(`/images/${id}`);
export const shareImage   = (id)           => api.post(`/images/${id}/share`);
export const unshareImage = (id)           => api.delete(`/images/${id}/share`);
export const getShared    = (token)        => api.get(`/images/share/${token}`);
export const saveFromUrl  = (data)         => api.post('/images/from-url', data);
export const exportImagesPdf = (ids, pageSize = 'fit') =>
  api.post('/images/export-pdf', { ids, pageSize }, { responseType: 'blob' });
export const bulkDeleteImages = (ids) => api.post('/images/bulk-delete', { ids });
export const bulkMoveImages   = (ids, folder_id) => api.post('/images/bulk-move', { ids, folder_id });
export const getImageKeys = () => api.get('/images/keys');
export const importImage  = (formData) =>
  api.post('/images/import', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
